/// <reference path="../../Common/Helpers/GridEditorBase.ts" />
/// <reference path="../../_ext/editors/grideditorbase.ts" />

namespace TabAurous.Production { 
    @Serenity.Decorators.registerClass()
    export class MFGInspectionValuesEditor extends _Ext.GridEditorBase<MFGInspectionValuesRow> { 
        protected getColumnsKey() { return "Production.MFGInspectionValues"; } 
        protected getLocalTextPrefix() { return MFGInspectionValuesRow.localTextPrefix; }
        protected form: MFGInspectionValuesForm; 
        constructor(container: JQuery) {
            super(container); 
        } 
        setData(items: any[]) {
            for (var i = 0; i < items.length; i++) {
                var qc = items[i];
                var newqc: MFGInspectionValuesRow = {
                    Max: qc.Max,
                    Min: qc.Min,
                    ExpectedValue: qc.ExpectedValue,
                    Parameter: qc.Parameter,
                    Remark: qc.Remark,
                    InspectedValue: qc.InspectedValue,
                    Status: qc.Status,                   

                }
                newqc[this.getIdProperty()] = "`" + this.nextId++;
                this.view.addItem(newqc);
            }
        }

    }
}